<template>
  <div v-html="item.content" ref="contentEl" class="tes-article__body-partial"/>
</template>

<script lang="ts">
import {PageTextData} from '../../../objects/Page'

import { onBeforeUnmount, onMounted, onUpdated, PropType, ref, Ref} from 'vue'
import {addEventListenerLazyPicture, fireLazyElement, unmountLazyElement} from "../../../objects/LazyImage";

export default {
  name: "PageTextView",
  props: {
    item: {type: Object as PropType<PageTextData>, required: true},
    index: {type: Number, required: true},
    sortNum: {},
    lazy: {},
    header: {},
    more: {}
  },
  setup() {
    const contentEl: Ref<HTMLElement | null> = ref<HTMLElement | null>(null)

    onMounted(() => {
      let pictures: NodeListOf<HTMLElement> = document.querySelectorAll('picture[data-preprocessed="true"]')
      Array.from(pictures).forEach(picture => {
        addEventListenerLazyPicture(picture)
        fireLazyElement(picture)
      })
    })

    onUpdated( () => {
      let pictures: NodeListOf<HTMLElement> = document.querySelectorAll('picture[data-preprocessed="true"]')
      Array.from(pictures).forEach(picture => {
        addEventListenerLazyPicture(picture)
        fireLazyElement(picture)
      })
    })

    onBeforeUnmount(() => {
      if (contentEl.value) {
        let pictures: NodeListOf<HTMLElement> = contentEl.value.querySelectorAll('picture[data-preprocessed="true"]')
        Array.from(pictures).forEach(picture => {
          unmountLazyElement(picture)
        })
      }
    });


    return {contentEl}
  }
}
</script>
